const MapSection = () => (
  <section className="w-full bg-[#F5F1EB] py-20 px-6 md:px-12 lg:px-20">
    <div className="max-w-7xl mx-auto grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
      {/* Content */}
      <div>
        <div className="flex items-center gap-3 mb-6">
          <div className="w-10 h-px bg-[#C9A96E]"></div>
          <span className="text-[#C9A96E] uppercase tracking-[0.3em] text-xs font-semibold">Find the Studio</span>
        </div>
        <h2 className="font-serif text-3xl md:text-4xl font-bold text-stone-800 leading-tight mb-5">
          Visit Deb&apos;s Art Designs
        </h2>
        <p className="text-stone-500 text-sm leading-relaxed mb-8">
          The studio is located in Pylesville, MD — serving clients locally and beyond with custom artwork and creative design services.
        </p>
        <div className="flex flex-col gap-4">
          <div className="flex items-start gap-4">
            <div className="w-9 h-9 flex items-center justify-center bg-[#C9A96E]/10 text-[#C9A96E] rounded-sm shrink-0">
              <i className="ri-map-pin-line text-base"></i>
            </div>
            <div>
              <p className="text-xs uppercase tracking-widest text-stone-400 mb-1">Studio Address</p>
              <a
                href="https://www.google.com/maps/dir//5246+Buttermilk+Road,+Pylesville,+MD+21132"
                target="_blank"
                rel="noopener noreferrer"
                className="text-stone-700 font-semibold text-sm hover:text-[#C9A96E] transition-colors"
              >
                5246 Buttermilk Road, Pylesville, MD 21132
              </a>
            </div>
          </div>
          <div className="flex items-start gap-4">
            <div className="w-9 h-9 flex items-center justify-center bg-[#C9A96E]/10 text-[#C9A96E] rounded-sm shrink-0">
              <i className="ri-instagram-line text-base"></i>
            </div>
            <div>
              <p className="text-xs uppercase tracking-widest text-stone-400 mb-1">Follow the Work</p>
              <a
                href="https://www.instagram.com/debsartdesigns"
                target="_blank"
                rel="noopener noreferrer"
                className="text-stone-700 font-semibold text-sm hover:text-[#C9A96E] transition-colors"
              >
                @debsartdesigns
              </a>
            </div>
          </div>
        </div>
      </div>

      {/* Map embed */}
      <div className="w-full h-[380px] overflow-hidden rounded-sm border border-stone-100">
        <iframe
          title="Deb's Art Designs Studio Location"
          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3054.0!2d-76.5917086!3d39.7534046!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x89c812abe8763ceb%3A0xcebdc388fcb01ac1!2sDeb's%20Art%20Designs%20Photography!5e0!3m2!1sen!2sus!4v1700000000000"
          width="100%"
          height="100%"
          style={{ border: 0 }}
          allowFullScreen
          loading="lazy"
          referrerPolicy="no-referrer-when-downgrade"
        ></iframe>
      </div>
    </div>
  </section>
);

export default MapSection;
